function initCarnovaScrollbar(carousel) {
  // Evita doppia inizializzazione
  if (carousel.dataset.carnovaInit === '1') return;
  carousel.dataset.carnovaInit = '1';

  // Wrappa se non già wrappato
  if (!carousel.parentElement.classList.contains('carousel-carnova-wrap')) {
    const wrap = document.createElement('div');
    wrap.className = 'carousel-carnova-wrap';
    carousel.parentNode.insertBefore(wrap, carousel);
    wrap.appendChild(carousel);
  }

  const wrap = carousel.parentElement;

  // Rimuovi scrollbar precedente
  const existingBar = wrap.querySelector('.carnova-scrollbar');
  if (existingBar) existingBar.remove();

  // Crea scrollbar — linea a sinistra, frecce a destra (come seconda immagine)
  const scrollbar = document.createElement('div');
  scrollbar.className = 'carnova-scrollbar';
  scrollbar.innerHTML = `
    <div class="carnova-scrollbar__track-wrap">
      <div class="carnova-scrollbar__thumb"></div>
    </div>
    <div class="carnova-scrollbar__buttons">
      <button class="carnova-scrollbar__btn" data-dir="-1" aria-label="Precedente">
        <svg viewBox="0 0 10 10"><polyline points="7,1 3,5 7,9"/></svg>
      </button>
      <button class="carnova-scrollbar__btn" data-dir="1" aria-label="Successivo">
        <svg viewBox="0 0 10 10"><polyline points="3,1 7,5 3,9"/></svg>
      </button>
    </div>
  `;
  wrap.appendChild(scrollbar);

  const thumbEl = scrollbar.querySelector('.carnova-scrollbar__thumb');
  const trackEl = scrollbar.querySelector('.carnova-scrollbar__track-wrap');

  let rafPending = false;

  const triggerBtn = carousel.closest('fieldset')?.querySelector('.carnova-panel-trigger');

  function updateScrollbar() {
    if (rafPending) return;
    rafPending = true;
    requestAnimationFrame(() => {
      const { scrollLeft, scrollWidth, clientWidth } = carousel;
      const isScrollable = scrollWidth > clientWidth + 2;
      // Mostra/nasconde scrollbar e trigger in base all'overflow
      scrollbar.style.display = isScrollable ? '' : 'none';
      if (triggerBtn) triggerBtn.style.display = isScrollable ? '' : 'none';
      const ratio = clientWidth / scrollWidth;
      const thumbWidth = Math.max(ratio * 100, 8);
      const maxScroll = scrollWidth - clientWidth;
      const thumbLeft = maxScroll > 0 ? (scrollLeft / maxScroll) * (100 - thumbWidth) : 0;
      thumbEl.style.width = thumbWidth.toFixed(2) + '%';
      thumbEl.style.left = thumbLeft.toFixed(2) + '%';
      wrap.classList.toggle('is-end', scrollLeft + clientWidth >= scrollWidth - 4);
      rafPending = false;
    });
  }

  // Click frecce
  scrollbar.querySelectorAll('.carnova-scrollbar__btn').forEach(btn => {
    btn.addEventListener('click', () => {
      const dir = parseInt(btn.dataset.dir);
      const labelW = (carousel.querySelector('label')?.offsetWidth || 100) + 8;
      carousel.scrollBy({ left: dir * labelW * 3, behavior: 'smooth' });
    });
  });

  // Click sulla track
  trackEl.addEventListener('click', (e) => {
    if (e.target === thumbEl) return;
    const rect = trackEl.getBoundingClientRect();
    const ratio = (e.clientX - rect.left) / rect.width;
    carousel.scrollLeft = ratio * (carousel.scrollWidth - carousel.clientWidth);
  });

  // Drag thumb
  let isDragging = false, dragStartX = 0, dragStartScrollLeft = 0;

  thumbEl.addEventListener('mousedown', (e) => {
    isDragging = true;
    dragStartX = e.clientX;
    dragStartScrollLeft = carousel.scrollLeft;
    e.preventDefault();
  });

  document.addEventListener('mousemove', (e) => {
    if (!isDragging) return;
    const rect = trackEl.getBoundingClientRect();
    const maxThumbLeft = rect.width - thumbEl.offsetWidth;
    if (maxThumbLeft <= 0) return;
    const dragRatio = (e.clientX - dragStartX) / maxThumbLeft;
    carousel.scrollLeft = dragStartScrollLeft + dragRatio * (carousel.scrollWidth - carousel.clientWidth);
  });

  document.addEventListener('mouseup', () => { isDragging = false; });

  carousel.addEventListener('scroll', updateScrollbar);
  window.addEventListener('resize', updateScrollbar);

  // Init dopo un frame per avere le dimensioni corrette
  requestAnimationFrame(updateScrollbar);
}

function buildPanelCategories(container) {
  container.querySelectorAll('.carnova-panel-grid').forEach(function(grid) {
    grid.querySelectorAll('.carnova-panel-category').forEach(function(el) { el.remove(); });
    let currentCat = null;
    Array.from(grid.children).forEach(function(item) {
      if (!item.classList.contains('carnova-panel-item')) return;
      const label = item.querySelector('[data-mo-handle]');
      const cat = (label && label.dataset.categoria) || '';
      if (cat !== currentCat) {
        currentCat = cat;
        if (cat !== '') {
          const header = document.createElement('div');
          header.className = 'carnova-panel-category';
          header.textContent = cat;
          grid.insertBefore(header, item);
        }
      }
    });
  });
}

function initAllCarnova() {
  document.querySelectorAll('.carousel-carnova').forEach(initCarnovaScrollbar);
}

document.addEventListener('DOMContentLoaded', initAllCarnova);

// savedScrolls: array con la posizione di ogni carosello prima del re-render
// pendingPanelOverride: override per il carosello specifico del pannello {index, position}
let savedScrolls = [];
let pendingPanelOverride = null;

// Capture phase: salva le posizioni di TUTTI i caroselli prima del re-render
document.addEventListener('change', function(e) {
  const vs = e.target.closest && e.target.closest('variant-selects');
  if (!vs) return;
  const carousels = Array.from(vs.querySelectorAll('.carousel-carnova[data-carnova-init="1"]'));
  savedScrolls = carousels.map(function(c) { return c.scrollLeft; });
  // Override per la selezione dal pannello (target centrato sulla variante scelta)
  if (pendingPanelOverride !== null) {
    var ov = pendingPanelOverride;
    pendingPanelOverride = null;
    if (ov.index >= 0 && ov.index < savedScrolls.length) {
      savedScrolls[ov.index] = ov.position;
    }
  }
}, true);

// Ripristina le posizioni di TUTTI i caroselli (idempotente: si consuma al primo uso)
function applyCarnovaScroll() {
  if (!savedScrolls.length) return;
  var scrolls = savedScrolls;
  savedScrolls = [];
  var vs = document.querySelector('variant-selects');
  if (!vs) return;
  var carousels = Array.from(vs.querySelectorAll('.carousel-carnova'));
  carousels.forEach(function(carousel, i) {
    if (scrolls[i] > 0) {
      carousel.scrollLeft = scrolls[i];
    }
  });
}

// Pannello varianti: sincronizza con il carosello e chiude il pannello
document.addEventListener('change', function(e) {
  if (e.target.type !== 'radio') return;
  const panel = e.target.closest('.carnova-variant-panel');
  if (!panel) return;

  // basic-modal viene spostato al <body>: ricaviamo section ID dall'ID pannello
  const optionValueId = e.target.dataset.optionValueId;
  if (optionValueId) {
    const sectionId = panel.id.replace(/^VariantPanel-/, '').replace(/-\d+$/, '');
    const variantSelects = document.getElementById('variant-selects-' + sectionId);
    if (variantSelects) {
      const carouselInput = variantSelects.querySelector(
        'fieldset input[data-option-value-id="' + optionValueId + '"]'
      );
      if (carouselInput && !carouselInput.checked) {
        // Identifica il carosello corretto e il suo indice tra tutti i caroselli
        const allCarousels = Array.from(variantSelects.querySelectorAll('.carousel-carnova'));
        const fieldset = carouselInput.closest('fieldset');
        const carousel = fieldset ? fieldset.querySelector('.carousel-carnova') : allCarousels[0];
        const carouselIndex = carousel ? allCarousels.indexOf(carousel) : 0;
        const label = variantSelects.querySelector('label[for="' + carouselInput.id + '"]');
        if (carousel && label) {
          const target = label.offsetLeft - (carousel.clientWidth / 2) + (label.offsetWidth / 2);
          pendingPanelOverride = { index: carouselIndex, position: Math.max(0, target) };
        }
        carouselInput.click(); // triggera la capture phase che legge pendingPanelOverride
      }
    }
  }

  // Chiude il pannello dopo la selezione
  setTimeout(function() {
    const closeBtn = panel.querySelector('.drawer__close-btn');
    if (closeBtn) closeBtn.click();
  }, 150);
});

// MutationObserver: inizializza nuovi caroselli e ripristina scroll
const carnovaObserver = new MutationObserver(() => {
  const newCarousels = document.querySelectorAll('.carousel-carnova:not([data-carnova-init])');
  if (!newCarousels.length) return;
  newCarousels.forEach(initCarnovaScrollbar);
  requestAnimationFrame(applyCarnovaScroll);
});

carnovaObserver.observe(document.body, { childList: true, subtree: true });

// variant:changed come backup (dispatchato su document dal tema dopo il re-render)
document.addEventListener('variant:changed', function() {
  requestAnimationFrame(applyCarnovaScroll);
});